<template>
  <div>
    <div class="w-100 px-5 py-4">
      <div slot="title">
        <h1>{{sesionDeLaAudiencia.Audiencia != undefined && sesionDeLaAudiencia.Audiencia != null ? sesionDeLaAudiencia.Audiencia.TipoDocumento.Nombre : "Cargando sesión de la audiencia"}} {{sesionDeLaAudiencia.Audiencia != undefined ? sesionDeLaAudiencia.Audiencia.Consecutivo : ""}}</h1>
        <h3>Preparación de la sala {{sesionDeLaAudiencia.Sala != undefined && sesionDeLaAudiencia.Sala != null ? sesionDeLaAudiencia.Sala.Nombre : ""}}</h3>
      </div>
      <div class="row d-flex">
        <div class="col-12 col-sm-12 col-md-12 col-lg-3 padding-div-low">
          <div class="area">
            <h2>Información</h2>
            <hr />
            <p><strong>Juzgado: </strong>{{sesionDeLaAudiencia.Audiencia != undefined && sesionDeLaAudiencia.Audiencia != null ? sesionDeLaAudiencia.Audiencia.Area.Nombre : "Sin información"}}</p>
            <p><strong>Materia: </strong>{{sesionDeLaAudiencia.Audiencia != undefined && sesionDeLaAudiencia.Audiencia != null ? sesionDeLaAudiencia.Audiencia.Materia.Nombre : "Sin información"}}</p>
            <p><strong>Tipo de audiencia: </strong>{{sesionDeLaAudiencia.Audiencia != undefined && sesionDeLaAudiencia.Audiencia != null ? sesionDeLaAudiencia.Audiencia.TipoAudiencia.Nombre : "Sin información"}}</p>
            <p v-html="obtenFechaDeAudienciaConFormato(sesionDeLaAudiencia.Audiencia != undefined && sesionDeLaAudiencia.Audiencia != null ? sesionDeLaAudiencia.Audiencia.FechaAudiencia : '')"></p>
            <p v-html="obtenHoraDeAudienciaConFormato(sesionDeLaAudiencia.Audiencia != undefined && sesionDeLaAudiencia.Audiencia != null ? sesionDeLaAudiencia.Audiencia.Duracion : '')"></p>
            <p v-if="sesionDeLaAudiencia.Audiencia != undefined && sesionDeLaAudiencia.Audiencia != null">
              <strong>Jueces: </strong>
              <ul v-if="sesionDeLaAudiencia.Audiencia.JuecesEnAudiencia.length > 0">
                <li v-for="juezEnAudiencia in sesionDeLaAudiencia.Audiencia.JuecesEnAudiencia">
                  {{juezEnAudiencia.Juez.Nombre}}{{juezEnAudiencia.Juez.ApellidoPaterno != "" ? " " + juezEnAudiencia.Juez.ApellidoPaterno : ""}}{{juezEnAudiencia.Juez.ApellidoMaterno != "" ? " " + juezEnAudiencia.Juez.ApellidoMaterno : ""}}
                </li>
              </ul>
              <span v-else>Sin jueces</span>
            </p>
            <p><strong>Estatus de la audiencia: </strong>{{sesionDeLaAudiencia.Audiencia != undefined && sesionDeLaAudiencia.Audiencia != null ? sesionDeLaAudiencia.Audiencia.TipoEstatusDeAudiencia.Nombre : "Sin información"}}</p>
            <br />
            <h3>Sesión</h3>
            <hr />
            <p><strong>Se ha realizado pruebas: </strong>{{sesionDeLaAudiencia.PruebaRealizada ? "Si" : "No"}}</p>
            <!--<p v-if="sesionDeLaAudiencia.PruebaRealizada == true && pruebaEnProceso == false"><strong>Sala: </strong>{{sesionDeLaAudiencia.Sala.Nombre}}</p>-->
            <C020Salas v-on:valorParaElPadre="cambioDeSala" :prefijo="enumeraciones.etiquetasDeHTML.Select" :tipo="enumeraciones.tiposDeSelect.Seleccione" :idDelInput="'preparacionDeSala_Sala'" :parametros="parametrosDeSala" :valorDefinido="sesionDeLaAudiencia.Sala != undefined && sesionDeLaAudiencia.Sala != null ? sesionDeLaAudiencia.Sala.SalaId : -1" :key="sesionDeLaAudiencia.Sala != undefined && sesionDeLaAudiencia.Sala != null ? sesionDeLaAudiencia.Sala.SalaId : -1"></C020Salas>
            <hr />
            <div class="justify-content-end text-right">
              <button class="btn btn-default mb-2" v-if="pruebaEnProceso == false" v-on:click="iniciarPrueba()">
                <i class="fas fa-clipboard"></i>&nbsp;&nbsp;Iniciar pruebas
              </button>
              <button class="btn btn-success mb-2" v-if="pruebaEnProceso == true" v-on:click="finalizarPrueba()">
                <i class="fas fa-clipboard-check"></i>&nbsp;&nbsp;Finalizar pruebas
              </button>
              <button class="btn btn-default mb-2" v-if="sesionDeLaAudiencia.PruebaRealizada == true && pruebaEnProceso == false" v-on:click="iniciarGrabacion()">
                <i class="fas fa-video"></i>&nbsp;&nbsp;Ir a grabar
              </button>
              <button class="btn btn-danger mb-2" v-on:click="cancelarPreparacionYSalir()">
                <i class="fas fa-times"></i>&nbsp;&nbsp;Salir
              </button>
            </div>
          </div>
        </div>
        <div v-if="pruebaEnProceso" class="col-12 col-sm-12 col-md-12 col-lg-9 padding-div-low">
          <div class="area">
            <h4>Sala {{sesionDeLaAudiencia.Sala != undefined && sesionDeLaAudiencia.Sala != null ? sesionDeLaAudiencia.Sala.Nombre : ""}}</h4>
            <h6>Realizando pruebas de las cámaras de la sala</h6>
            <hr />
            <div class="row">
              <div class="justify col-6" v-if="sesionDeLaAudiencia.Camaras.length > 0">
                <div class="col-12">
                  <h6>Cámaras a usar en la audiencia</h6>
                </div>
                <div>
                  <table class="table table-striped table-light table-hover">
                    <thead class="thead-dark">
                      <tr>
                        <th></th>
                        <th>Cámara</th>                                               
                      </tr>
                    </thead>
                    <tbody class="text-dark">
                      <input type="checkbox" id="selectAll" v-on:click="selectAllTable(camarasDeSala)"> Seleccionar todas las cámaras <br>
                      <tr v-if="camarasDeSala.length == 0" class="text-center">
                        <td colspan="4">No existe informacion a mostrar</td>
                      </tr>                      
                      <tr v-else v-for="(camara, index) in camarasDeSala" :key="'camara' + index">                         
                        <div id="listChecked">
                        <td><input type="checkbox" v-bind:value="camara.CamaraId" :id="camara.CamaraId" v-on:click="cargarCamaras(camara)" :checked="camara.Activo"/></td>
                        <td>{{camara.TipoCamara.Nombre}}</td>                                                
                      </div>
                      </tr>
                    </tbody>
                  </table>          
                </div>  
              </div> 
            <div class="justify col-6" v-if="camaraDeProtegido.ExisteCamara == true">
              <div v-if="protegidoActivo==true">
              <div class="col-12">
                <h6>Formato del vídeo del protegido</h6>
              </div>
              <div class="col-12">
                <label for="blurDeVideoProtegido">¿El vídeo va a ir con imagen difuminada?</label>
                <select id="blurDeVideoProtegido" class="form-control" v-model="camaraDeProtegido.Video.ElVideoSeDifumina" v-on:change="establecerDifuminado()">
                  <option value="false">No</option>
                  <option value="true">Si</option>
                </select>
              </div>
              </div>
              <br />
              <div class="col-12 justify-content-end text-right">
                <button class="btn btn-success mb-2" v-if="!estaGrabandoPrueba && !pruebaGrabado" v-on:click="iniciarGrabaciónPrueba()">
                  <i class="fas fa-video"></i>&nbsp;&nbsp;Grabar prueba
                </button>
                <button class="btn btn-danger mb-2" v-if="estaGrabandoPrueba && !pruebaGrabado" v-on:click="ejecutaLaFinalizacionDeLaGrabacion()">
                  <i class="fas fa-stop"></i>&nbsp;&nbsp;Parar grabación de prueba
                </button>
                <button class="btn btn-default mb-2" v-if="pruebaGrabado">
                  <i class="fas fa-video"></i>&nbsp;&nbsp;Prueba grabada con éxito
                </button>                
              </div>
              <!--<div class="col-6">
                <label for="blurDeAudioProtegido">¿El audio va a ir modificado?</label>
                <C015TiposDistorsionesDeAudio v-on:valorParaElPadre="cambioDeTiposDistorsionDeAudio" :prefijo="enumeraciones.etiquetasDeHTML.Select" :tipo="enumeraciones.tiposDeSelect.Seleccione" :idDelInput="'preparacionDeSala_TipoDeDistorsionDeAudio'" :parametros="{}" :valorDefinido="camaraDeProtegido.Video.TipoDistorsionDeAudio.TipoDistorsionDeAudioId" ></C015TiposDistorsionesDeAudio>
              </div>-->
            </div>                     
            </div>
            <hr />
            <Reproductor :reproducirVideo="false" :parametros="sesionDeLaAudiencia" :key="sesionDeLaAudiencia.Sala != undefined && sesionDeLaAudiencia.Sala != null ? sesionDeLaAudiencia.Sala.Nombre + camaraDeProtegido.Video.ElVideoSeDifumina + indexReproductor : camaraDeProtegido.Video.ElVideoSeDifumina + indexReproductor"></Reproductor>
          </div>
        </div>
      </div>
    </div>
    <audio ref="audio_forseti" :src='audioSource' type="audio/mp3" :controls='false' ></audio>
  </div>
</template>

<script>
  import sistemas from '@/../static/js/sistemas';
  import enumeraciones from '@/../static/js/enumeraciones'
  import catalogos from '@/../static/js/catalogos'
  import api from '@/../static/js/api'
  import comun from '@/../static/js/comun'
  import router from '@/router/index'
  import axios from 'axios'

  export default {
    components: {
      enumeraciones,
      Reproductor: sistemas.Forseti.Reproductor,
      C020Salas: catalogos.PJ.C020Salas,
      C015TiposDistorsionesDeAudio: catalogos.Forseti.C015TiposDistorsionesDeAudio
    },
    data() {
      return {
        enumeraciones,
        sesionDeLaAudiencia: {},
        camarasDeSala: [],
        parametrosDeSala: {
          AreaId: -1
        },
        pruebaEnProceso: false,
        camaraDeProtegido: {
          ExisteCamara: false,
          BlurDeVideoProtegido: 0,
          TipoDeDistorsionDeAudio: -1
        },
        protegidoActivo:false,
        indexReproductor: 1,
        estaGrabandoPrueba: false,
        pruebaGrabado: false,     
        audioSource: null
      }
    },
    props: {
      SesionDeLaAudienciaId: Number,
      AudienciaId: Number
    },
    mounted() {
      this.obtenSesionDeLaAudienciaAPreparar();
    },
    methods: {
      iniciarGrabaciónPrueba: function(){                
       let camarasActivas = this.camarasDeSala.filter(cam => cam.Activo);

       if(camarasActivas.length < 4){
          comun.mensajeDeAlerta("No se pueden grabar menos de 4 cámaras activas para una sesión", null, null);
          comun.SeEstaCargandoInformacion(false); 
        }else{

        comun.SeEstaCargandoInformacion(true);        
        
        const parametros = {
          rutaDeVideo: this.sesionDeLaAudiencia.RutasDeVideos[0],
          camaras: this.sesionDeLaAudiencia.Camaras,
          esPruebaSala: true,
          EsPrueba: true
        }

        axios.post(
          'http://' + this.sesionDeLaAudiencia.Sala.IP + this.sesionDeLaAudiencia.Sala.PuertoDeGrabacion + api.Forseti.sistema.audiencias.audienciaspendientes.EjecutarGrabacionDeSala,
          parametros,
          comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
          ).then(respuesta => {
            if (respuesta.data.Error != undefined) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error, null, null);              
            } else {
              this.estaGrabandoPrueba = true;
            }
            comun.SeEstaCargandoInformacion(false);
          }
          ).catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
            comun.SeEstaCargandoInformacion(false);
          });
        }
      },
      ejecutaLaFinalizacionDeLaGrabacion: async function() {
        return axios.post(
          'http://' + this.sesionDeLaAudiencia.Sala.IP + this.sesionDeLaAudiencia.Sala.PuertoDeGrabacion + api.Forseti.sistema.audiencias.audienciaspendientes.EjecutarFinalizacionDeGrabacionDeSala,
          {"Ruta": this.sesionDeLaAudiencia.RutasDeVideos[0].Ruta,
           'esPruebaSala' : true },
          comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
          ).then(respuesta => {
            if (respuesta.Error != undefined) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.Error, null, null);
              throw respuesta
            } else {
              this.estaGrabandoPrueba = false;
              this.pruebaGrabado = true;
              return respuesta;
            }
          }
          ).catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
            comun.SeEstaCargandoInformacion(false);
          });
      },
      validarTamaños: function(){ 
        let camarasActivas = this.camarasDeSala.filter(cam => cam.Activo);
        //console.log(camarasActivas);        
        if(camarasActivas.length > 7){
          comun.mensajeDeAlerta("No se pueden mostrar más de 7 cámaras", null, null);
          return false;
        }else{ 
          switch(camarasActivas.length){
            case 6:
            case 5:                            
                  camarasActivas.forEach(element => { 
                    if(element.TamanoDeLaCamara != 4){                      
                      this.$nextTick(() => {                        
                        this.cambiarEstatusDeCamara(element.CamaraId, null, 4)
                      });                      
                      this.$set(this.camarasDeSala.find(cam => cam.CamaraId == element.CamaraId), 'TamanoDeLaCamara', 4);
                    }
                  });                
              break;            
            case 4: 
            case 3:
            case 2:                                   
                  camarasActivas.forEach(element => {                     
                    if(element.TamanoDeLaCamara != 6){                      
                      this.$nextTick(() => {
                        this.cambiarEstatusDeCamara(element.CamaraId, null, 6)
                      });                      
                      this.$set(this.camarasDeSala.find(cam => cam.CamaraId == element.CamaraId), 'TamanoDeLaCamara', 6);
                    }
                  });                     
              break;                                
            case 1:                              
                  camarasActivas.forEach(element => { 
                    if(element.TamanoDeLaCamara != 12){
                      this.cambiarEstatusDeCamara(element.CamaraId, null, 12)                      
                      this.$set(this.camarasDeSala.find(cam => cam.CamaraId == element.CamaraId), 'TamanoDeLaCamara', 12);
                    }
                  });                          
              break;
            default:              
              break;

          }          
        };
        /*if(camarasActivas.length < 4){
          comun.mensajeDeAlerta("No se pueden mostrar menos de 4 cámaras", null, null);
          return false;
        }*/
        this.indexReproductor ++;
      },
      cargarCamaras: function(camara){                                
        this.cambiarEstatusDeCamara(camara.CamaraId, !camara.Activo);                           
        this.camarasDeSala.find(cam => cam.CamaraId == camara.CamaraId).Activo = !camara.Activo;
        this.validarTamaños();       
        if(camara.TipoCamara.TipoCamaraId == 5){
        this.protegidoActivo=(camara.Activo)?true:false; 
        }
        //console.log("this.protegidoActivo: "+this.protegidoActivo);
      },
      cambiarEstatusDeCamara: async function(CamaraId, activo, tamaño){
        comun.SeEstaCargandoInformacion(true);
        
        const parametros = {
          CamaraId: CamaraId,
          Activo: activo,
          Tamaño: parseInt(tamaño)
        };

        axios.post(
          api.conexion + api.Forseti.sistema.audiencias.audienciaspendientes.CambiarEstatusCamaraDeSala,
          parametros,
          comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
          ).then(respuesta => {
            if(respuesta.data.SiHayError){
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);              
            } else {
              this.indexReproductor ++;
              
            }
            comun.SeEstaCargandoInformacion(false);
          }
          ).catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
            comun.SeEstaCargandoInformacion(false);
            router.push({ name: "PanelDeAudienciasPendientes" });
          });
      },
      establecerDifuminado: function(){            
        this.sesionDeLaAudiencia.RutasDeVideos[0].ElVideoSeDifumina = this.camaraDeProtegido.Video.ElVideoSeDifumina;
        //this.sesionDeLaAudiencia.RutasDeVideos.find(e=>e.Camara.TipoCamara.TipoCamaraId == 5).ElVideoSeDifumina = this.camaraDeProtegido.Video.ElVideoSeDifumina;
        this.indexReproductor ++;
      },
      obtenFechaDeAudienciaConFormato: function(fechaDeAudiencia) {
        if(fechaDeAudiencia != "")
          return moment(fechaDeAudiencia).locale('es').format("[<strong>Fecha y hora: </strong>]DD [de] MMMM [del] YYYY [a las] h:mm a");
        else
          return "<strong>Fecha y hora: </strong>Sin información";
      },
      obtenHoraDeAudienciaConFormato: function(horaDeAudiencia) {
        if(horaDeAudiencia != "")
          return moment(horaDeAudiencia, "HH:mm:ss").locale('es').format("[<strong>Duración: </strong>]h:mm [hora(s)]");
        else
          return "<strong>Duración: </strong>Sin información";
      },
      verificaSiExisteUnaCamaraParaProtegido: function (camaras) { 
        if(camaras != null && camaras.length > 0 && camaras != undefined)
          camaras.forEach((camara, index) => {
            if(camara.TipoCamara.TipoCamaraId == 5) {
              this.camaraDeProtegido = {
                ExisteCamara: true,
                Video: camara
              }
              if(this.camaraDeProtegido.Video.TipoDistorsionDeAudio == null)
                this.camaraDeProtegido.Video.TipoDistorsionDeAudio = {
                  TipoDistorsionDeAudioId: -1
                }
              if(this.camaraDeProtegido.Video.ElVideoSeDifumina == null)
                this.camaraDeProtegido.Video.ElVideoSeDifumina = false;
              if(camara.Activo && this.protegidoActivo==false)
                  this.protegidoActivo=true;
            }                        
          })
      },
      obtenSesionDeLaAudienciaAPreparar: function() {
        comun.SeEstaCargandoInformacion(true);
        const parametros = {
          SesionDeLaAudienciaId: this.SesionDeLaAudienciaId,
          EsPrueba: this.enumeraciones.EsPrueba
        };

        axios.post(
          api.conexion + api.Forseti.sistema.audiencias.audienciaspendientes.ObtenSesionDeLaAudienciaPendiente,
          parametros,
          comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
          ).then(respuesta => {
            if(respuesta.data.SiHayError){
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
              this.$store.dispatch('A_ReglasDeRuteo', { aDondeSeRuteaOElError: respuesta.data.Error.MensajeId });
            } else {
              this.sesionDeLaAudiencia = respuesta.data.SesionDeLaAudienciaPendiente; 
              //this.EjecutaTransmisionAudio();
              //Se quita la handycam
              this.camarasDeSala = this.sesionDeLaAudiencia.Camaras.filter(cam => cam.TipoCamara.TipoCamaraId != 8);

              //Se verifica si ya se grabó vídeo de prueba
              this.pruebaGrabado = this.sesionDeLaAudiencia.VideoDePruebaRealizado;

              this.verificaSiExisteUnaCamaraParaProtegido(this.sesionDeLaAudiencia.Camaras)
            }
            comun.SeEstaCargandoInformacion(false);
          }
          ).catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
            comun.SeEstaCargandoInformacion(false);
            router.push({ name: "PanelDeAudienciasPendientes" });
          });
      },
      iniciarPrueba: function() {
        bootbox.confirm({
          title: "Mensaje del sistema",
          message: "¿Desea iniciar la preparación de la sala?",
          buttons: {
            cancel: {
              label: '<i class="fa fa-times"></i>&nbsp;&nbsp;No'
            },
            confirm: {
              label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Si'
            }
          },
          callback: (respuesta) => {
            comun.SeEstaCargandoInformacion(true);
            if (respuesta) {
              this.pruebaEnProceso = true;
              this.EjecutaTransmisionAudio();
              setTimeout(()=>{
                const audio_audiencia = this.$refs.audio_forseti;
                audio_audiencia.src = this.sesionDeLaAudiencia.Sala.IPDeTransmision;
                audio_audiencia.preload= "none";
                audio_audiencia.play();
              }, 1500);
            }
            else
            {
              this.finalizarTransmision();
              this.finalizarEvidenciador();
            }
            comun.SeEstaCargandoInformacion(false);
          }
        });
      },
      cambioDeTiposDistorsionDeAudio: function(datos){
        this.camaraDeProtegido.Video.TipoDistorsionDeAudio.TipoDistorsionDeAudioId = parseInt(datos.target.value)
      },
      finalizarPrueba: function() {
        bootbox.confirm({
          title: "Mensaje del sistema",
          message: "¿Desea finalizar la preparación de la sala?",
          buttons: {
            cancel: {
              label: '<i class="fa fa-times"></i>&nbsp;&nbsp;No'
            },
            confirm: {
              label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Si'
            }
          },
          callback: (respuesta) => {
            if (respuesta) {
              if((this.camarasDeSala.filter(cam => cam.Activo)).length<4){
              comun.mensajeDeAlerta("Para finalizar la preparación de la sala debe haber mínimo 4 cámaras activas, favor de seleccionarlas.", null, null);
            }else if(this.estaGrabandoPrueba){
              comun.mensajeDeAlerta("Para finalizar la preparación de la sala debe parar la grabación de prueba de la audiencia", null, null);
            }else{
              comun.SeEstaCargandoInformacion(true);
              this.finalizarTransmision();
              this.finalizarEvidenciador();
              const parametros = {
                SesionDeLaAudienciaId: this.sesionDeLaAudiencia.SesionDeLaAudienciaId,
                PruebaFueRealizada: true,
                VideoDePruebaFueRealizado: this.pruebaGrabado,
                EsPrueba: this.enumeraciones.EsPrueba
              }
              if(this.camaraDeProtegido.ExisteCamara) {
                let videoParaConfiguracion = this.camaraDeProtegido.Video;
                //if(videoParaConfiguracion.TipoDistorsionDeAudio.TipoDistorsionDeAudioId == -1) >-- comentado linea original se modifica para verificar si objeto TipoDistorsionadorDeAudio no es nulo
                if(videoParaConfiguracion.TipoDistorsionDeAudio!=null && videoParaConfiguracion.TipoDistorsionDeAudio.TipoDistorsionDeAudioId == -1)
                  videoParaConfiguracion.TipoDistorsionDeAudio = null;
                parametros.ConfiguracionDeCamaraProtegida = videoParaConfiguracion;
              }
              axios.post(
                api.conexion + api.Forseti.sistema.audiencias.audienciaspendientes.GuardarPruebasRealizadasyCreaRutasDeVideos,
                parametros,
                comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
                ).then(respuesta => {
                  if(respuesta.data.SiHayError){
                    console.log(respuesta);
                    comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    this.$store.dispatch('A_ReglasDeRuteo', { aDondeSeRuteaOElError: respuesta.data.Error.MensajeId });
                    comun.SeEstaCargandoInformacion(false);
                  } else {
                    this.pruebaEnProceso = false;
                    //this.EjecutaTransmisionAudio();
                    this.obtenSesionDeLaAudienciaAPreparar();
                    this.iniciarGrabacion();
                  }
                }
                ).catch(excepcion => {
                  console.log(excepcion);
                  comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                  comun.SeEstaCargandoInformacion(false);
                });
            }
            }
          }
        });
      },
      iniciarGrabacion: function() {
        this.finalizarTransmision();
        this.finalizarEvidenciador();
        let _this = this;
        bootbox.confirm({
          title: "Mensaje del sistema",
          message: "¿Iniciar la grabación de la audiencia?",
          buttons: {
            cancel: {
              label: '<i class="fa fa-times"></i>&nbsp;&nbsp;No'
            },
            confirm: {
              label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Si'
            }
          },
          callback: (respuesta) => {
            if (respuesta) {
              router.push({ name: "Grabacion", params: { SesionDeLaAudienciaId: _this.sesionDeLaAudiencia.SesionDeLaAudienciaId, AudienciaId: this.AudienciaId } });
            }
          }
        });
      },
      cancelarPreparacionYSalir: function() {
        let _this = this;
        bootbox.confirm({
          title: "Mensaje del sistema",
          message: "¿Salir de la preparación de la sala?",
          buttons: {
            cancel: {
              label: '<i class="fa fa-times"></i>&nbsp;&nbsp;No'
            },
            confirm: {
              label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Si, salir'
            }
          },
          callback: function (respuesta) {
            if (respuesta) {
              _this.finalizarTransmision();
              _this.finalizarEvidenciador();
              router.push({ name: "PanelDeAudienciasPendientes" });
            }
          }
        });
      },
      cambioDeSala: function(datos) {
        comun.SeEstaCargandoInformacion(true);

        const parametros = {
          SesionDeLaAudienciaId: this.sesionDeLaAudiencia.SesionDeLaAudienciaId,
          SalaId: parseInt(datos.target.value),
          EsPrueba: this.enumeraciones.EsPrueba
        }

        axios.post(
          api.conexion + api.Forseti.sistema.audiencias.audienciaspendientes.GuardarCambioDeSala,
          parametros,
          comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
          ).then(respuesta => {
            if(respuesta.data.SiHayError){
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
              this.$store.dispatch('A_ReglasDeRuteo', { aDondeSeRuteaOElError: respuesta.data.Error.MensajeId });
              comun.SeEstaCargandoInformacion(false);
            } else {
              this.obtenSesionDeLaAudienciaAPreparar();
            }
          }
          ).catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
            comun.SeEstaCargandoInformacion(false);
          });
      },
      EjecutaTransmisionAudio: async function(datos)
      {
        return axios.post(
          'http://' + this.sesionDeLaAudiencia.Sala.IP + this.sesionDeLaAudiencia.Sala.PuertoDeGrabacion + api.Forseti.sistema.audiencias.audienciaspendientes.EjecutarTransmisionAudio,
          { },
          comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
          ).then(respuesta => {
            if (respuesta.Error != undefined) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.Error, null, null);
              throw respuesta
            } else {
              // setTimeout(()=>{
              //   const audio_audiencia = this.$refs.audio_forseti;
              //   audio_audiencia.src = this.sesionDeLaAudiencia.Sala.IPDeTransmision;
              //   audio_audiencia.play();
              // }, 1500);
              return respuesta;
            }
          }
          ).catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
            comun.SeEstaCargandoInformacion(false);
          });
      },
      finalizarTransmision: async function(){

        return axios.post(
          'http://' + this.sesionDeLaAudiencia.Sala.IP + this.sesionDeLaAudiencia.Sala.PuertoDeGrabacion + api.Forseti.sistema.audiencias.audienciaspendientes.TerminarTransmisionAudio,
          { },
          comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
          ).then(respuesta => {
            if (respuesta.Error != undefined) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.Error, null, null);
              throw respuesta
            } else {
              return respuesta;
            }
          }
          ).catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
            comun.SeEstaCargandoInformacion(false);
          });
      },
      finalizarEvidenciador: async function(){

        return axios.post(
          'http://' + this.sesionDeLaAudiencia.Sala.IP + this.sesionDeLaAudiencia.Sala.PuertoDeGrabacion +  "/DetenerConversion",
          { },
          comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
          ).then(respuesta => {
            if (respuesta.Error != undefined) {
              comun.mensajeDeAlerta(respuesta.Error, null, null);
              throw respuesta
            } else {
              return respuesta;
            }
          }
          ).catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
            comun.SeEstaCargandoInformacion(false);
          });
      },
      selectAllTable:function(camarasDeSala) {
        if(document.getElementById('selectAll').checked){
        for(let i=0; i<camarasDeSala.length;i++){
        this.cambiarEstatusDeCamara(camarasDeSala[i].CamaraId, true);
        document.getElementById(camarasDeSala[i].CamaraId).disabled= true;
        }
        this.validarTamaños(); 
        } else{
        for(let i=0; i<camarasDeSala.length;i++){
        this.cambiarEstatusDeCamara(camarasDeSala[i].CamaraId, camarasDeSala[i].Activo);
        document.getElementById(camarasDeSala[i].CamaraId).disabled= false;
        } 
        }
        }
    },
    beforeRouteLeave (to, from, next) {
        if(this.estaGrabandoPrueba)
        {
          comun.mensajeDeAlerta('Actualmente existe una grabación de prueba en curso, detenga el proceso para salir', null, null);
          next(false);
        }
        else
        {
          const audio_audiencia = this.$refs.audio_forseti;
          audio_audiencia.pause();
          audio_audiencia.src = "";
          this.finalizarTransmision();
          this.finalizarEvidenciador();
          next()
        }
    }
    
  }
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// src/components/Forseti/Audiencias/PanelDeAudienciasPendientes/PreparacionDeSala.vue